<template>
<v-app id="inspire">
    <v-content>
        <v-container fluid fill-height>
            <v-layout wrap justify-center style="display: flex">
                <v-flex xs3 sm3 md3>
                    <v-layout wrap justify-center align-center style="display: flex; margin-top: 15vh;">
                        <v-flex xs12 sm12 md12>
                            <div class="logo-login">
                                <img :src="logo">
                                <div class="animation-shap-login">
                                    <div class="shap-bg"></div>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <v-form ref="form">
                                <label class="label-modal">E-mail</label>
                                <v-text-field @keyup.enter.native="login" color="red darken-1" :rules="defaultRules" autocomplete="off" prepend-icon="person" type="text" v-model="email"></v-text-field>
                                <label class="label-modal">Password</label>
                                <v-text-field @keyup.enter.native="login" color="red darken-1" :rules="defaultRules" prepend-icon="lock" type="password" v-model="password"></v-text-field>
                            </v-form>
                        </v-flex>
                        <v-flex xs12 sm12 md12 justify-end style="display: flex">
                            <v-btn v-on:click.stop="login()" color="red darken-1" :loading="loading" class="white--text">Entrar</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <div class="year">
                    <div>
                        <span>&copy; {{currentYear}} Hema - Todos os direitos reservados</span>
                    </div> 
                </div>
            </v-layout>
        </v-container>
    </v-content>
</v-app>
</template>

<script>
import {
    mapState,
    mapActions,
    mapGetters
} from "vuex";

export default {
    data: () => ({
        logo: require('@/assets/logo.png'),
        email: '',
        password: '',
        loading: false,
        defaultRules: ''
    }),
    computed: {
        ...mapGetters({
            getSession: 'session/getState'
        }),
        currentYear() {
            return this.$moment().format('YYYY');
        }
    },
    created() {
        this.defaultRules = [v => !!v || this.$requiredField + ''];
    },
    methods: {
        login() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;
            this.$store.dispatch("session/signIn", {
                email: this.email,
                password: this.password
            }).then((res) => {
                if (res) {
                    this.$eventBus.$emit('login', this.getSession.session);
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.$toast.error('Os dados introduzidos não são válidos.');
                }
            });
        }
    }
}
</script>

<style scoped>
.logo-login {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-bottom: 5vh !important;
    position: relative;
}

.logo-login img {
    width: 80% !important;
    z-index: 3;
}

button {
    margin-right: 0 !important;
}

.animation-shap-login {
    width: 50%;
    position: absolute;
    height: 120%;
    top: 0%;
    right: 0%;
}

.year {
  position: absolute !important;
  bottom: 10px !important;
  font-weight: bold !important;
  display: flex !important;
  text-transform: uppercase !important;
  font-size: 12px !important;
}

.year div {
  display: flex !important;
  justify-content: center !important;

}
</style>
